<div class="sameta-fe-candidate-section-title">
  @if(title){
  <span class="title">{{ title }}</span>
  } @if(caption){
  <span class="caption">{{ caption }}</span>
  }
</div>
